import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import * as selectors from './selectors'
import { SETTINGS_KEYS } from 'Global/constants'
import { getAdvisorOptions, getReservationEventOptions, getReservationUserOptions } from 'Global/Stores/options'
import { getTokenFromLocalStorage } from 'Global/Helpers/localStorageHelpers'
import { getUserSetting } from 'Global/Helpers/userHelpers'
import { groupsGet } from 'Global/Stores/groups'
import { layoutSetAll, sortBySetAll, sortOrderSetAll } from 'Global/Stores/layout'
import { setDefaultsSet, signInFromLs, timestampLogin, updateUserGroups } from 'Global/Stores/auth'

export default WrappedComponent => {
  class RequireAuth extends Component {
    static propTypes = {
      advisorDone: PropTypes.bool.isRequired,
      children: PropTypes.node,
      defaultsSet: PropTypes.bool.isRequired,
      getAdvisorOptions: PropTypes.func.isRequired,
      getGroups: PropTypes.func.isRequired,
      getReservationEventOptions: PropTypes.func.isRequired,
      getReservationUserOptions: PropTypes.func.isRequired,
      groupsDone: PropTypes.bool.isRequired,
      groupsPending: PropTypes.bool.isRequired,
      location: PropTypes.object.isRequired,
      redirectToSignIn: PropTypes.func.isRequired,
      reservationEventDone: PropTypes.bool.isRequired,
      reservationUserDone: PropTypes.bool.isRequired,
      router: PropTypes.object.isRequired,
      setDefaultsSet: PropTypes.func.isRequired,
      setLayout: PropTypes.func.isRequired,
      setSortBy: PropTypes.func.isRequired,
      setSortOrder: PropTypes.func.isRequired,
      signInFromLs: PropTypes.func.isRequired,
      timestampLogin: PropTypes.func.isRequired,
      updateUserGroups: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    componentDidMount() {
      const { redirectToSignIn, user } = this.props

      if (!user.token) {
        const lsUser = getTokenFromLocalStorage()

        if (lsUser) {
          this.signInFromLs(lsUser)
        } else {
          redirectToSignIn()
        }
      } else {
        this.setDefaults()
      }

      this.getGroups()
    }

    getGroups = () => {
      const { getGroups, groupsDone, groupsPending } = this.props

      if (!groupsDone && !groupsPending) {
        getGroups()
      }
    }

    getOptions = () => {
      const {
        advisorDone,
        getAdvisorOptions,
        getReservationEventOptions,
        getReservationUserOptions,
        reservationEventDone,
        reservationUserDone,
      } = this.props

      if (!advisorDone) {
        getAdvisorOptions()
      }

      if (!reservationEventDone) {
        getReservationEventOptions()
      }

      if (!reservationUserDone) {
        getReservationUserOptions()
      }
    }

    setDefaults = () => {
      const { defaultsSet, setDefaultsSet, setLayout, setSortBy, setSortOrder, timestampLogin, user } = this.props

      const layout = getUserSetting(user, SETTINGS_KEYS.LAYOUT)
      const sortBy = getUserSetting(user, SETTINGS_KEYS.SORT_BY)
      const sortOrder = getUserSetting(user, SETTINGS_KEYS.SORT_ORDER)

      if (!defaultsSet) {
        if (layout) {
          setLayout(layout)
        }

        if (sortBy) {
          setSortBy(sortBy)
        }

        if (sortOrder) {
          setSortOrder(sortOrder)
        }

        timestampLogin(user)

        setDefaultsSet()
      }

      this.getOptions()
    }

    signInFromLs = user => {
      const { updateUserGroups, signInFromLs } = this.props

      signInFromLs(user)
      updateUserGroups(user.id)
    }

    render() {
      const { children, location, router, user } = this.props

      if (user && user.token) {
        return <WrappedComponent children={children} location={location} router={router} />
      }

      return null
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    advisorDone: selectors.advisorDone(state),
    defaultsSet: selectors.defaultsSet(state),
    groupsDone: selectors.groupsDone(state),
    groupsPending: selectors.groupsPending(state),
    reservationEventDone: selectors.reservationEventDone(state),
    reservationUserDone: selectors.reservationUserDone(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    getAdvisorOptions: () => dispatch(getAdvisorOptions()),
    getGroups: () => dispatch(groupsGet()),
    getReservationEventOptions: () => dispatch(getReservationEventOptions()),
    getReservationUserOptions: () => dispatch(getReservationUserOptions()),
    redirectToSignIn: user => dispatch(push('/signIn')),
    setDefaultsSet: () => dispatch(setDefaultsSet()),
    setLayout: layout => dispatch(layoutSetAll(layout)),
    setSortBy: sortBy => dispatch(sortBySetAll(sortBy)),
    setSortOrder: sortOrder => dispatch(sortOrderSetAll(sortOrder)),
    signInFromLs: user => dispatch(signInFromLs(user)),
    timestampLogin: user => dispatch(timestampLogin(user)),
    updateUserGroups: user => dispatch(updateUserGroups(user)),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(RequireAuth)
}
